import { render, staticRenderFns } from "./ConfirmList.vue?vue&type=template&id=3c8df90b"
import script from "./ConfirmList.vue?vue&type=script&lang=js"
export * from "./ConfirmList.vue?vue&type=script&lang=js"
import style0 from "./ConfirmList.vue?vue&type=style&index=0&id=3c8df90b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports